export const STATIC_PATH = PRODUCTION ? '/front' : '';
export const STATIC_PATH_S3 = 'https://static.tutorplace.ru/affiliate/';
